/* eslint-disable react/no-array-index-key */
import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import { Box, Typography } from '@mui/material';
import { useQuery } from '@apollo/client';
import Skeleton from '@mui/lab/Skeleton';
import Spacer from '@atoms/Spacer';
import { SEARCH_OPPORTUNITY } from 'apollo/queries';
import OpportunityCard from '@organisms/opportunities/OpportunityCard';
import { useTranslation } from '@app/config/i18n';

import { useUser } from '@app/helpers/hooks';
import { redirectToRoute } from '@app/helpers';
import { CardContainer } from './style';

const OrganisationOpportunities = ({ organisationSlug }) => {
  const { t } = useTranslation('common');
  const { user }  = useUser();

  const { 
    data: {
      opportunitySearch: { data: opportunities } = { data:[] }
    } = {}, 
    loading: opportunitiesLoading 
  } = useQuery(SEARCH_OPPORTUNITY, {
    variables: {
      first: 10,
      input: {
        organisation: organisationSlug,
      },
    },
  });

  const handleViewOpportunity = (slug) => () => {
    redirectToRoute({}, 'view_opportunity', { params: { slug } });
  };


  return (
    <>
      <Grid container>
        {opportunitiesLoading && (
          <>
            <Grid item xs={12} sm={12}>
              <Box padding="1rem" marginBottom="5rem">
                <Skeleton animation="wave" variant="rect" height={35} width="30%" />
              </Box>
            </Grid>
            {Array.from(new Array(6)).map((opportunity, index) => (
              <Grid key={index} item xs={12} sm={12} md={6} lg={4}>
                <CardContainer>
                  <OpportunityCard loading />
                </CardContainer>
              </Grid>
            ))}
          </>
        )}

        {opportunities.length > 0 && (
          <>
            <Grid item xs={12} sm={12}>
              <Spacer height="1rem" />
              <Typography variant="h5" gutterBottom>
                {t('opportunity_plural')}
              </Typography>
              <Spacer height="2rem" />

              {/* <PageHeader title={t('opportunity_plural')} icon={<LibraryMusicRoundedIcon />} /> */}
            </Grid>
            {opportunities.map((opportunity) => (
              <Grid key={opportunity.id} item xs={12} sm={12} md={6} lg={6}>
                <CardContainer>
                  <OpportunityCard
                    userInfo={user}
                    {...opportunity}
                    onClick={handleViewOpportunity(opportunity.slug)}
                  />
                </CardContainer>
              </Grid>
            ))}
          </>
        )}
      </Grid>
    </>
  );
};

OrganisationOpportunities.propTypes = {
  organisationSlug: PropTypes.string.isRequired,
};

export default OrganisationOpportunities;
